import React from "react";

export default function TaskUserPicker({
  employees,
  selectedIds,
  onChange,
  placeholder = "Добавить",
  excludeIds = [],
}) {
  const selectedSet = new Set(selectedIds);
  const excludeSet = new Set(excludeIds);
  const selected = selectedIds
    .map((id) => employees.find((emp) => emp.id === id))
    .filter(Boolean);
  const available = employees.filter(
    (emp) => !selectedSet.has(emp.id) && !excludeSet.has(emp.id)
  );

  const handleAdd = (value) => {
    if (!value) return;
    const id = Number(value);
    if (!id || selectedSet.has(id)) return;
    onChange([...selectedIds, id]);
  };

  const handleRemove = (id) => {
    onChange(selectedIds.filter((selectedId) => selectedId !== id));
  };

  return (
    <div className="task-user-picker">
      {selected.length > 0 && (
        <div className="task-user-chips">
          {selected.map((user) => (
            <span key={user.id} className="task-user-chip">
              <span className="task-user-chip-name">{user.full_name}</span>
              <button
                type="button"
                className="task-user-chip-remove"
                onClick={() => handleRemove(user.id)}
                aria-label={`Убрать ${user.full_name}`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
      <select
        className="task-form-select"
        value=""
        onChange={(e) => {
          handleAdd(e.target.value);
          e.target.value = "";
        }}
        disabled={available.length === 0}
      >
        <option value="">{available.length === 0 ? "Все добавлены" : placeholder}</option>
        {available.map((emp) => (
          <option key={emp.id} value={emp.id}>
            {emp.full_name}
          </option>
        ))}
      </select>
    </div>
  );
}
